import { Box, Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HOVER_ACTIONS_CLASS = 'hover-actions';

export const HoverActionsCard = styled(Card)({
  position: 'relative',
  [`&:hover .${HOVER_ACTIONS_CLASS}`]: { opacity: 1 },
});

export const HoverActionsRoot = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  right: theme.spacing(5.5),
  transform: 'translateY(-50%)',
  zIndex: 2,
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(0.75),
  // Theme-derived so the overlay stays readable in dark mode.
  backgroundColor: theme.palette.background.paper,
  opacity: 0,
  transition: 'opacity 0.15s ease-in-out',
}));
